import { render, staticRenderFns } from "./ProfWidget2.vue?vue&type=template&id=1049a056&"
import script from "./ProfWidget2.vue?vue&type=script&lang=js&"
export * from "./ProfWidget2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports